// @flow
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Form from '../components/AddPatientForm'
import { Box, Radio, Heading } from '@medeo/components'

import { PatientContext } from './AddPatientChannel'
import FormFooter from '../components/AddPatientFormFooter'

type PatientInfo = {
  given: string,
  family: string,
  address: string,
  postcode: string,
  country: string,
  gender: string,
  birthDate: string,
  email: string,
  phone: string,
  socialSecurityNo: string,
  practitioner: string
}
type DispatchProps = {
  selectDisease: PatientInfo => void
}

type Props = DispatchProps

const Fieldset = Box.withComponent('div')

const DiseasesForm = ({ selectDisease, disease, history }: Props) => {
  const onSubmit = e => {
    e.preventDefault()
    const { elements } = e.currentTarget
    selectDisease(elements.namedItem('disease').value)
    history.push('/patients/add/step-2')
  }
  return (
    <Form onSubmit={onSubmit} autoComplete="false">
      <Heading size={20}>Pathologie du patient</Heading>
      <Fieldset>
        <FormattedMessage id="heartFailure">
          {label => (
            <Radio
              label={label}
              name="disease"
              value="heartFailure"
              id="heartFailure"
              defaultChecked={disease === 'heartFailure'}
              required
            />
          )}
        </FormattedMessage>
        <FormattedMessage id="kidneyFailure">
          {label => (
            <Radio
              label={label}
              name="disease"
              value="kidneyFailure"
              id="kidneyFailure"
              required
            />
          )}
        </FormattedMessage>
        <FormattedMessage id="type1Diabetes">
          {label => (
            <Radio
              label={label}
              name="disease"
              value="type1Diabetes"
              id="type1Diabetes"
              defaultChecked={disease === 'type1Diabetes'}
              required
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="type2Diabetes1Injection">
          {label => (
            <Radio
              label={label}
              name="disease"
              value="type2Diabetes1Injection"
              id="type2Diabetes1Injection"
              defaultChecked={disease === 'type2Diabetes1Injection'}
              required
            />
          )}
        </FormattedMessage>
        <FormattedMessage id="type2DiabetesOtherSchemas">
          {label => (
            <Radio
              label={label}
              name="disease"
              value="type2DiabetesOtherSchemas"
              id="type2DiabetesOtherSchemas"
              defaultChecked={disease === 'type2DiabetesOtherSchemas'}
              required
            />
          )}
        </FormattedMessage>
      </Fieldset>
      <FormFooter previous="/patients" />
    </Form>
  )
}

export default props => (
  <PatientContext.Consumer>
    {context => (
      <DiseasesForm
        {...props}
        selectDisease={context.selectDisease}
        disease={context.state.disease}
      />
    )}
  </PatientContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/Patients/containers/DiseasesForm.js